export default __webpack_public_path__ + "static/media/Security.2ec61411.svg";